const NotFound = () => (
    <div className="text-center fs-1 my-5 py-5">Stránka nenalezena</div>
)

export default NotFound;